import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    dialog: {
      maxHeight: "80vh",
      minHeight: "auto",
      maxWidth: "80vw",
      [theme.breakpoints.down("sm")]: {
        maxHeight: 700,
        maxWidth: "96vw",
      },
      [theme.breakpoints.up("lg")]: {
        maxHeight: 900,
        maxWidth: 900,
      },
      "& .vo-global__content-with-toolbar": {
        boxShadow: "none",
        padding: 0,
      },
      "& .vo-global__content-toolbar": {
        padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        zIndex: 2,
      },
    },
  })
);
